// api
export const GET_ARCADE_CABINETS = 'API_FETCH__GET_ARCADE_CABINETS';
export const GET_ARCADE_CABINET = 'API_FETCH__GET_ARCADE_CABINET';
export const POST_ARCADE_CABINET = 'API_FETCH__POST_ARCADE_CABINET';
export const PUT_ARCADE_CABINET = 'API_FETCH__PUT_ARCADE_CABINET'; 
export const DELETE_ARCADE_CABINET = 'API_FETCH__DELETE_ARCADE_CABINET';

// section
export const ARCADE_CABINETS__SET_CABINET_LIST = 'ARCADE_CABINETS__SET_CABINET_LIST';

// panel
export const ARCADE_CABINETS__SET_CABINET = 'ARCADE_CABINETS__SET_CABINET';
export const ARCADE_CABINETS__CLEAR_CABINET = 'ARCADE_CABINETS__CLEAR_CABINET';
export const ARCADE_CABINETS__SET_CABINET_VALUE = 'ARCADE_CABINETS__SET_CABINET_VALUE';
export const ARCADE_CABINETS__SELECT_ROM = 'ARCADE_CABINETS__SELECT_ROM';
